<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <plano ref="plano" :plain_file="plain_file"></plano>
              <h1>Guias exportación</h1>
              <div align="right"></div>
              <v-server-table
                :url="url"
                :columns="columns"
                :options="options"
                :theme="theme"
                ref="table"
                id="dataTable"
              >
                <div slot="beforeLimit">
                  <download-excel
                    class="btn"
                    :fetch="fetchData"
                    :fields="json_fields2"
                    worksheet="Guias"
                    :name="name"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                  >
                    <b-link>Descargar</b-link>
                  </download-excel>
                </div>

                <template slot="afterFilter">
                  <tr v-if="loading" class="VueTables__no-results">
                    <b-spinner
                      v-if="loading"
                      variant="primary"
                      class="ml-2 mt-1"
                      small
                      label="Small Spinner"
                    ></b-spinner>
                  </tr>
                </template>

                <div class="text-right" slot="actions" slot-scope="props">
                  <a
                    title="Reporte"
                    target="_blank"
                    href="#"
                    @click.prevent="
                      showProcessModal(
                        props.row.waybill.id,
                        props.row.shipment.id
                      )
                    "
                    class="fa fa-lg fa-search text-black-50"
                  ></a
                  >&nbsp;
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="
                      downloadWithAxios(
                        props.row.waybill.id,
                        props.row.waybill.number
                      )
                    "
                    class="fa fa-lg fa fa-list text-black-50"
                    title="Packing List (español)"
                  ></a
                  >&nbsp;
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="
                      downloadPackingListEnglish(
                        props.row.waybill.id,
                        props.row.waybill.number
                      )
                    "
                    class="fa fa-lg fa fa-list text-info"
                    title="Packing List (inglés)"
                  ></a
                  >&nbsp;
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="mostrarArchivoPlano(props.row.waybill.id)"
                    class="fa fa-lg fa-code text-black-50 pr-1"
                    title="Archivo Plano"
                  ></a>
                  <a
                    title="ver estiba"
                    target="_blank"
                    href="#"
                    @click.prevent="
                      stowageModal(
                        props.row.waybill.id,
                        props.row.shipment.id,
                        props.row.waybill.number,
                        props.row.waybill.waybill_date
                      )
                    "
                    class="fa fa-lg fa-cube text-black-50"
                  ></a
                  >&nbsp;
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="edit(props.row)"
                    class="fa fa-lg fa-edit text-black-50"
                    title="Editar"
                  ></a
                  >&nbsp;
                  <!--            <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#" class="fa fa-lg fa-trash text-danger" title="Eliminar"></a>-->
                </div>

                <div
                  class="text-right"
                  slot="waybill.waybill_date"
                  slot-scope="props"
                >
                  {{ props.row.waybill.waybill_date | date_format }}
                </div>
              </v-server-table>

              <b-modal
                v-model="modalShownBordingInstructive"
                centered
                size="lg"
                title="Instructivos de embarque"
                hide-footer
              >
                <component
                  :is="componenteActual"
                  :idBording="idBording"
                  :shipment="shipment"
                  :ref="report"
                ></component>
              </b-modal>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="modalEstiba"
      centered
      size="xl"
      title="Estiba"
      @ok="closeModal"
      ok-only
    >
      <ReportStowage
        :waybill="waybill"
        :waybill_number="waybill_number"
        :waybill_date="waybill_date"
        :shipment_id="shipment_id"
      ></ReportStowage>
    </b-modal>

    <b-modal
      ref="infoModalWaybill"
      centered
      size="xl"
      title="Reporte"
      @ok="closeModal2"
      @close="closeModal2"
      ok-only
    >
      <component
        v-if="dataReport"
        :is="componenteActual"
        :dataReport="dataReport"
        ref="ReportWaybill"
      ></component>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import ReportInstructivoEmbarqueMaritimo from "../ReportInstructivoEmbarqueMaritimo.vue";
import ReportInstructivoEmbarqueAereo from "../ReportInstructivoEmbarqueAereo.vue";
import ReportFacturaExportacion from "../ReportFacturaExportacion.vue";
import ReportStowage from "./ReportStowage.vue";
import ReportWaybill from "./ReportWaybill.vue";
import Plano from "../Plano.vue";
import numeral from "numeral";
import locales from "numeral/locales";

import JsonExcel from "vue-json-excel";
import moment from "moment";

Vue.component("downloadExcel", JsonExcel);

window.axios = require("axios");

Vue.use(ServerTable);

export default {
  name: "ListGuiaExportacion",
  components: {
    ServerTable,
    ReportInstructivoEmbarqueMaritimo,
    ReportInstructivoEmbarqueAereo,
    Plano,
    ReportFacturaExportacion,
    ReportStowage,
    ReportWaybill
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  props: [],
  data() {
    return {
      dataReport: "",
      waybill: "",
      waybill_number: "",
      waybill_date: "",
      shipment_id: "",
      loading: false,
      plain_file: {
        filename: "",
        header: "",
        pallets: {}
      },
      loading: false,
      modalShownBordingInstructive: false,
      idBording: 0,
      shipment: "",
      componenteActual: "",
      report: "",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Numero: "waybill"
      },
      columns: [
        // 'id',
        "waybill.number",
        "waybill.waybill_date",
        "shipment.boarding_number",
        "vgm",
        "sag_sheet",
        "sag_worker.get_full_name",
        "actions"
      ],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            /* results[key].waybill_date = moment(results[key].waybill_date).format('DD-MM-YYYY');
              results[key].total_kilograms = numeral(parseFloat(results[key].total_kilograms)); */
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        debounce: 700,
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: [
          "waybill.number",
          "waybill.waybill_date",
          "shipment.boarding_number",
          "sag_sheet"
        ],
        headings: {
          "waybill.number": "Numero",
          "waybill.waybill_date": "Fecha",
          "shipment.boarding_number": "Embarque",
          vgm: "Vgm",
          sag_sheet: "Planilla SAG",
          "sag_worker.get_full_name": "Contraparte SAG",
          actions: "Acciones"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        Numero: "waybill.number",
        Embarque: "shipment.boarding_number",
        Vgm: {
          field: "vgm",
          callback: (value) => {
            return numeral(parseFloat(value)).format("0.00");
          }
        },
        "Planilla SAG": "sag_sheet",
        "Contraparte SAG": "sag_worker.get_full_name"
      }
    };
  },
  filters: {
    date_format(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    url() {
      return "/api/comex/export_waybill/detailed/";
    },
    name() {
      return (
        "GuiasExportacion " +
        moment(Date.now()).format("YYYYMMDD h:mm") +
        ".xls"
      );
    }
  },
  methods: {
    showProcessModal(id_waybill, shipment_id) {
      this.componenteActual = "ReportWaybill";
      this.loading = true;
      this.$nextTick(function () {
        this.getWaybillPallet(id_waybill, shipment_id);
      });

      this.$refs.infoModalWaybill.show();
    },
    getWaybillPallet(id_waybill, shipment_id) {
      axios
        .get("/api/comex/export_waybill/waybill_export_pallets/", {
          params: {
            id_waybill: id_waybill,
            shipment_id: shipment_id
          }
        })
        .then((res) => {
          this.dataReport = res.data;
        })
        .catch((error) => console.log(error));
    },
    closeModal() {
      this.loading = false;
      this.$refs.modalEstiba.hide();
    },
    closeModal2() {
      this.loading = false;
    },
    stowageModal(waybillExport, shipmentId, waybillnumber, waybilldate) {
      this.waybill = waybillExport;
      this.shipment_id = shipmentId;
      this.waybill_number = waybillnumber;
      (this.waybill_date = waybilldate), this.$refs.modalEstiba.show();
    },
    async fetchData() {
      const response = await this.$axios.get(
        "/api/comex/export_waybill/detailed/"
      );

      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Packing List - Guia #" + a + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/api/comex/export_waybill/" + a + "/packing_list/",
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
        })
        .catch(() => console.log("error occured"));
    },
    downloadPackingListEnglish(a, b) {
      this.$axios({
        method: "get",
        url: "/api/comex/export_waybill/" + a + "/packing_list_en/",
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
        })
        .catch(() => console.log("error occured"));
    },

    mostrarArchivoPlano(a) {
      this.$axios
        .get("/api/comex/export_waybill/" + a + "/plain_file/")
        .then((res) => {
          this.plain_file.filename = res.data.plain_file.filename;
          this.plain_file.header = res.data.plain_file.header;
          this.plain_file.pallets = res.data.plain_file.pallets;
        })
        .catch((error) => {
          this.plain_file.filename = "ERROR";
          this.plain_file.header = "ERROR";
          this.plain_file.pallets = "ERROR";
          console.log(error);
        });
      this.$refs.plano.showModal();
    },
    status(shipment_status) {
      return shipment_status === 2 ? "DESPACHADO" : "ABIERTO";
    },
    getBadge(shipment_status) {
      return shipment_status === 2 ? "dark" : "light";
    },
    showBoardinInstructiveModal(a) {
      //es maritimo
      if (a.shipment_type.id == 1) {
        this.modalShownBordingInstructive = true;
        this.idBording = a.id;
        this.shipment = a;
        this.componenteActual = "ReportInstructivoEmbarqueMaritimo";

        this.report = "report";
        this.$nextTick(function () {
          this.$refs.report.calcular();
        });
      }

      //es aereo
      if (a.shipment_type.id == 2) {
        this.modalShownBordingInstructive = true;
        this.idBording = a.id;
        this.shipment = a;
        this.componenteActual = "ReportInstructivoEmbarqueAereo";

        this.report = "report";
        this.$nextTick(function () {
          this.$refs.report.calcular();
        });
      }
    },
    showExportInvoiceModal(a) {
      this.modalShownBordingInstructive = true;
      this.idBording = a.id;
      this.shipment = a;
      this.componenteActual = "ReportFacturaExportacion";

      this.report = "report";
      this.$nextTick(function () {
        this.$refs.report.calcular();
      });
    },
    edit(row) {
      //console.log("objeto->%o",row.waybill.id);
      //guiaDespachoExportacion
      this.$router.push(
        "/exportacion/editar-guia-exportacion/" + row.waybill.id
      );
    },
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
